var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
var _desc, _value, _class, _descriptor, _descriptor2;
function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  Object.defineProperty(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;
  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }
  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);
  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }
  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }
  return desc;
}
function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}
import { observable, action, computed } from 'mobx';
import { cloneDeep, at, merge } from 'lodash';
var TranslationsStore = (_class = function () {
  function TranslationsStore() {
    _classCallCheck(this, TranslationsStore);
    _initDefineProp(this, 'locale', _descriptor, this);
    _initDefineProp(this, 'translations', _descriptor2, this);
  }
  TranslationsStore.prototype.translate = function translate(key) {
    if (this.currentTranslation) {
      try {
        return at(this.currentTranslation, key)[0] || key;
      } catch (e) {
        console.error(key + ' not found');
        return key;
      }
    }
  };
  TranslationsStore.prototype.addTranslation = function addTranslation(locale, translation) {
    this.translations[locale] = translation;
  };
  TranslationsStore.prototype.setLocale = function setLocale(locale) {
    this.locale = locale;
  };
  _createClass(TranslationsStore, [{
    key: 'currentTranslation',
    get: function get() {
      return merge(cloneDeep(this.translations['it']), this.translations[this.locale]);
    }
  }]);
  return TranslationsStore;
}(), (_descriptor = _applyDecoratedDescriptor(_class.prototype, 'locale', [observable], {
  enumerable: true,
  initializer: function initializer() {
    return 'it';
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, 'translations', [observable], {
  enumerable: true,
  initializer: function initializer() {
    return {};
  }
}), _applyDecoratedDescriptor(_class.prototype, 'setLocale', [action], Object.getOwnPropertyDescriptor(_class.prototype, 'setLocale'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'currentTranslation', [computed], Object.getOwnPropertyDescriptor(_class.prototype, 'currentTranslation'), _class.prototype)), _class);
export default new TranslationsStore();